import React, { useState } from 'react';
import { Info } from 'lucide-react';
import { Button } from './button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';

interface InfoTooltipProps {
  title: string;
  description: string;
  className?: string;
  side?: 'top' | 'bottom' | 'left' | 'right';
}

export function InfoTooltip({
  title,
  description,
  className = '',
  side = 'top',
}: InfoTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className={`h-5 w-5 p-0 rounded-full hover:bg-blue-100 transition-all duration-200 ${className}`}
          >
            <Info className="h-3 w-3 text-blue-600 hover:text-blue-700" />
          </Button>
        </TooltipTrigger>
        <TooltipContent
          className="max-w-sm p-5 bg-white border-2 border-blue-100 shadow-xl rounded-lg z-50"
          side={side}
          align="center"
          sideOffset={8}
          avoidCollisions={true}
          collisionPadding={16}
        >
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 rounded-full bg-blue-500 mt-1.5 shrink-0"></div>
              <div className="space-y-2">
                <h4 className="font-bold text-sm text-slate-900 leading-tight">{title}</h4>
                <p className="text-sm text-slate-700 leading-relaxed font-medium">{description}</p>
              </div>
            </div>
            <div className="h-px bg-linear-to-r from-blue-200 to-transparent"></div>
            <div className="text-xs text-blue-600 font-medium">ℹ️ Click anywhere to close</div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
